import { IconWrapper } from '../runtime';
export default IconWrapper('preview', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5.75 4.74969H10.25M15 14.9997L13.5 13.4997M14.25 11.4997C14.25 13.0185 13.0188 14.2497 11.5 14.2497C9.98122 14.2497 8.75 13.0185 8.75 11.4997C8.75 9.98091 9.98122 8.74969 11.5 8.74969C13.0188 8.74969 14.25 9.98091 14.25 11.4997Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M7 14.2497H4.25C3.42157 14.2497 2.75 13.5781 2.75 12.7497V3.24969C2.75 2.42127 3.42157 1.74969 4.25 1.74969H11.75C12.5784 1.74969 13.25 2.42127 13.25 3.24969V6.49969",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});